import * as React from 'react';
import { observer } from 'mobx-react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { I18N_NS } from 'Config/i18n';
import { ProjectFilesSearch } from '../EmailSendModal/ProjectFilesSearch';
import { ProjectDocumentsTable } from '../../../../Components/General/AddFilesInput/ProjectDocumentsTable';
import { emailSubmitStore } from '../Stores/EmailSubmitStore';
import { message } from 'antd';

interface AttachProjectFilesProps extends WithTranslation {
  toggleModal: () => void;
}

type attachSection = 'NAV' | 'SEARCH';

interface AttachProjectFilesState {
  renderSection: attachSection; // enums that represent showing of certain section
}

export const AttachProjectFiles = withTranslation(I18N_NS.PROJECT)(observer(
  class extends React.Component<AttachProjectFilesProps, AttachProjectFilesState> {
    constructor(props: AttachProjectFilesProps) {
      super(props);

      this.state = {
        renderSection: 'NAV',
      };
    }

    toggleSection = () => {
      const renderSection = this.state.renderSection === 'NAV' ? 'SEARCH' : 'NAV';
      this.setState({ renderSection });
    }

    handleAddAttachments = (data) => {
      if (!data.length) {
        message.error(this.props.t('No files selected'));
      } else {
        data.forEach((file) => {
          emailSubmitStore.addProjectFile(file);
        });
        this.props.toggleModal();
      }
    }

    render() {

      if (this.state.renderSection === 'NAV') {
        return (
          <ProjectDocumentsTable
            handleAddAttachments={this.handleAddAttachments}
            onShowSearch={this.toggleSection}
            onExit={this.props.toggleModal}
            minimumAccessLevel="READONLY"
          />
        );
      } else if (this.state.renderSection === 'SEARCH') {
        return <ProjectFilesSearch onCancel={this.toggleSection} onExit={this.props.toggleModal} />;
      } else {
        return null;
      }
    }
  }
));